/* This file is autogenerated, see readme.md for instructions */
import DisabledSvgIcon from '@bloomreach/banana-theme/icons/disabled.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const DisabledIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <DisabledSvgIcon />
    </Icon>
  );
});

DisabledIcon.displayName = 'DisabledIcon';

export default DisabledIcon;
